<label id="{{id}}_label"
  for='{{id}}_input'
  [ngClass]="{'visually-hidden' : !label }">
  @if (label) {
    <span>
      {{ label | translate }}
      @if (required) {
        <a>*</a>
      }
    </span>
  } @else {
    Bitte wählen Sie einen Wert aus
  }
  @if (hinweis) {
    <wba-fragezeichen
      label="{{label ? label : 'Auswahlbox'}}"
      [dataTarget]="hinweis?.target"
      [dataModal]="hinweis?.modal"
      id="{{id}}_fragezeichen"
      smaller="true"/>
  }
</label>

<select id="{{id}}_input"
  class='form-select'
  [ngClass]="{ 'ba-error' : isInvalid}"
  [name]='name'
  [attr.aria-label]='ariaLabel'
  [attr.data-has-error]="control?.touched && control?.errors && (control.errors['typ'] === 'error')"
  [attr.data-error-message]="control.errors?.message"
  (blur)="onBlur()"
  (change)="onChange($event)">
  <option value="" disabled selected>
    Bitte auswählen
  </option>
  @for (item of items; track item) {
    <option [value]="item.value"
            [selected]="item.value === value">
      {{ item.label | translate }}
    </option>
  }
</select>
@if (isInvalid) {
  <wba-error-message
    class="wba-form-select"
    _id="{{id}}"
    [control]="control"/>
}
